import TTCLogo from '../assets/ttc-logo.png';
import CreditCards from '../assets/credit-cards.png';
const IMAGES = {
    TTCLogo,
    CreditCards
}

export default IMAGES;